import { Button, Form, Input } from 'antd';
import { formItemLayout, tailFormItemLayout } from 'utils/formConfig';

// ─── shared names-only edit form ───────────────────────────────────────────────

export const ICBEditForm = ({ form, submiting, onFinish, initialValues = {}, name }) => (
  <Form
    {...formItemLayout}
    form={form}
    name={name}
    onFinish={onFinish}
    initialValues={initialValues}
    scrollToFirstError
  >
    <Form.Item
      name="name"
      label="Name"
      rules={[{ required: true, message: 'Name is required' }]}
    >
      <Input />
    </Form.Item>
    <Form.Item name="name_en" label="Name (EN)">
      <Input />
    </Form.Item>

    <Form.Item {...tailFormItemLayout}>
      <Button type="primary" htmlType="submit" loading={submiting}>
        Save
      </Button>
    </Form.Item>
  </Form>
);

// ─── Industry create form ──────────────────────────────────────────────────────

export const IndustryCreateForm = ({ form, submiting, onFinish, initialValues = {} }) => (
  <Form
    {...formItemLayout}
    form={form}
    name="industry-create"
    onFinish={onFinish}
    initialValues={initialValues}
    scrollToFirstError
  >
    <Form.Item
      name="code"
      label="Code"
      extra="4-digit ICB code, e.g. 8000"
      rules={[{ required: true, message: 'Code is required' }]}
    >
      <Input maxLength={4} style={{ width: 120 }} />
    </Form.Item>
    <Form.Item
      name="name"
      label="Name"
      rules={[{ required: true, message: 'Name is required' }]}
    >
      <Input />
    </Form.Item>
    <Form.Item name="name_en" label="Name (EN)">
      <Input />
    </Form.Item>
    <Form.Item {...tailFormItemLayout}>
      <Button type="primary" htmlType="submit" loading={submiting}>
        Create
      </Button>
    </Form.Item>
  </Form>
);

// ─── SuperSector create form ───────────────────────────────────────────────────

export const SuperSectorCreateForm = ({ form, submiting, onFinish, initialValues = {} }) => (
  <Form
    {...formItemLayout}
    form={form}
    name="supersector-create"
    onFinish={onFinish}
    initialValues={initialValues}
    scrollToFirstError
  >
    <Form.Item
      name="code"
      label="Code"
      extra="4-digit ICB code, e.g. 8300"
      rules={[{ required: true, message: 'Code is required' }]}
    >
      <Input maxLength={4} style={{ width: 120 }} />
    </Form.Item>
    <Form.Item
      name="name"
      label="Name"
      rules={[{ required: true, message: 'Name is required' }]}
    >
      <Input />
    </Form.Item>
    <Form.Item name="name_en" label="Name (EN)">
      <Input />
    </Form.Item>
    <Form.Item
      name="industry_code"
      label="Industry Code"
      extra="Parent industry code, e.g. 8000"
      rules={[{ required: true, message: 'Industry code is required' }]}
    >
      <Input maxLength={4} style={{ width: 120 }} />
    </Form.Item>
    <Form.Item {...tailFormItemLayout}>
      <Button type="primary" htmlType="submit" loading={submiting}>
        Create
      </Button>
    </Form.Item>
  </Form>
);

// ─── Sector create form ───────────────────────────────────────────────────────

export const SectorCreateForm = ({ form, submiting, onFinish, initialValues = {} }) => (
  <Form
    {...formItemLayout}
    form={form}
    name="sector-create"
    onFinish={onFinish}
    initialValues={initialValues}
    scrollToFirstError
  >
    <Form.Item
      name="code"
      label="Code"
      extra="4-digit ICB code, e.g. 8350"
      rules={[{ required: true, message: 'Code is required' }]}
    >
      <Input maxLength={4} style={{ width: 120 }} />
    </Form.Item>
    <Form.Item
      name="name"
      label="Name"
      rules={[{ required: true, message: 'Name is required' }]}
    >
      <Input />
    </Form.Item>
    <Form.Item name="name_en" label="Name (EN)">
      <Input />
    </Form.Item>
    <Form.Item
      name="supersector_code"
      label="SuperSector Code"
      extra="Parent supersector code, e.g. 8300"
      rules={[{ required: true, message: 'SuperSector code is required' }]}
    >
      <Input maxLength={4} style={{ width: 120 }} />
    </Form.Item>
    <Form.Item {...tailFormItemLayout}>
      <Button type="primary" htmlType="submit" loading={submiting}>
        Create
      </Button>
    </Form.Item>
  </Form>
);

// ─── SubSector create form ────────────────────────────────────────────────────

export const SubSectorCreateForm = ({ form, submiting, onFinish, initialValues = {} }) => (
  <Form
    {...formItemLayout}
    form={form}
    name="subsector-create"
    onFinish={onFinish}
    initialValues={initialValues}
    scrollToFirstError
  >
    <Form.Item
      name="code"
      label="Code"
      extra="4-digit ICB code, e.g. 8355"
      rules={[{ required: true, message: 'Code is required' }]}
    >
      <Input maxLength={4} style={{ width: 120 }} />
    </Form.Item>
    <Form.Item
      name="name"
      label="Name"
      rules={[{ required: true, message: 'Name is required' }]}
    >
      <Input />
    </Form.Item>
    <Form.Item name="name_en" label="Name (EN)">
      <Input />
    </Form.Item>
    <Form.Item
      name="sector_code"
      label="Sector Code"
      extra="Parent sector code, e.g. 8350"
      rules={[{ required: true, message: 'Sector code is required' }]}
    >
      <Input maxLength={4} style={{ width: 120 }} />
    </Form.Item>
    <Form.Item {...tailFormItemLayout}>
      <Button type="primary" htmlType="submit" loading={submiting}>
        Create
      </Button>
    </Form.Item>
  </Form>
);
